import { SCOPE as PARENT_SCOPE } from '../types';
export const SCOPE = `${PARENT_SCOPE}.sharing`;
export const SET_SHARING = `${SCOPE}/SET_SHARING`;
